import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {

  ngOnInit(): void {
    // Logic to be executed when the component is initialized
    // For example, you can fetch data or perform any setup here
    console.log('ComingSoonComponent initialized');
  }

}
